import React, { Component } from 'react'
import { CreateUsers } from '../../components'
import createUser from '../../helpers/createUser'

class CreateUsersContainer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      email: '',
      displayName: '',
      role: 'Student',
      password: ''
    }

    this.handleClick = this.handleClick.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }
  
//Need to handle errors, based on createUser outcomes (prob need to make it return a promise)
//Need to add redux actions
//Add git versioning etc.

  handleClick(e) {
    e.preventDefault()
    createUser(
      this.state.email, 
      this.state.password, 
      this.state.role, 
      {}, 
      {},
      this.state.displayName,
    )
  } 

  handleChange(e) {
    const value = e.target.value
    this.setState({
      [e.target.name] : value
    })
  }

  render() {
    return ( 
      <CreateUsers
        email={this.state.email}
        displayName={this.state.displayName}
        role={this.state.role}
        password={this.state.password}
        handleClick={this.handleClick}
        handleChange={this.handleChange}
      />
    )
  }
}

export default CreateUsersContainer


// WEBPACK FOOTER //
// ./src/containers/Users/CreateUsersContainer.js